import { Fragment, useEffect, useState } from "react";
import { InfoPage } from "../utils/types";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Renders **bold** segments inside info panel strings. */
function renderInfoText(message: string) {
  const parts = message.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <Fragment key={index}>{part}</Fragment>;
  });
}

interface LastPageAction {
  text: string;
  onClick: () => void;
}

export interface InfoNavPanelProps {
  infoPages: InfoPage[];
  lastPageAction: LastPageAction;
}

const InfoNavPanel = ({ infoPages, lastPageAction }: InfoNavPanelProps) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [messages, setMessages] = useState<string[]>([]);

  const activePage = infoPages[pageIndex];

  useEffect(() => {
    if (activePage) {
      setMessages(activePage.text);
    } else {
      setMessages([]);
    }
  }, [activePage]);

  if (!infoPages.length) {
    return null;
  }

  const previousButtonDisabled = pageIndex === 0;

  function handlePreviousPage() {
    setPageIndex((currentIndex) => {
      if (currentIndex > 0) {
        return currentIndex - 1;
      }
      return 0;
    });
  }

  function handleNextPage() {
    setPageIndex((currentIndex) => {
      if (currentIndex === infoPages.length - 1) {
        return currentIndex;
      }

      return currentIndex + 1;
    });
  }

  const messageList = messages.map((message, index) => (
    <li key={`${pageIndex}-${index}`}>
      <p className="info-nav-text">{renderInfoText(message)}</p>
    </li>
  ));

  return (
    <div className="info-nav-panel hidden-scrollbar">
      <h3 className="info-nav-header">{activePage.title}</h3>
      <ol>{messageList}</ol>
      <div className="buttons-footer">
        <button
          className={`btn equal-btns ${previousButtonDisabled ? "disabled-btn" : ""}`}
          onClick={handlePreviousPage}
          disabled={previousButtonDisabled}
        >
          <FontAwesomeIcon icon={faAngleLeft} /> Previous
        </button>
        {pageIndex === infoPages.length - 1 ? (
          <button className="btn equal-btns" onClick={lastPageAction.onClick}>
            {lastPageAction.text}
          </button>
        ) : (
          <button className="btn equal-btns" onClick={handleNextPage}>
            Next <FontAwesomeIcon icon={faAngleRight} />
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoNavPanel;
